<template>
  <v-app>
    <vertical-nav-menu :is-drawer-open.sync="isDrawerOpen"></vertical-nav-menu>

    <v-app-bar v-if="!$route.meta.hideSidebar" app flat absolute color="transparent">
      <div class="boxed-container w-full">
        <div class="d-flex align-center mx-6">
          <!-- Left Content -->
          <v-app-bar-nav-icon class="d-block d-lg me-2" @click="isDrawerOpen = !isDrawerOpen"></v-app-bar-nav-icon>
          <!--search 
          <v-text-field
            rounded
            dense
            outlined
            :prepend-inner-icon="icons.mdiMagnify"
            class="app-bar-search flex-grow-0"
            hide-details
          ></v-text-field> -->

          <v-spacer></v-spacer>

          <!-- Right Content -->
          <!--  <a
            href="https://github.com/themeselection/materio-vuetify-vuejs-admin-template-free"
            target="_blank"
            rel="nofollow"
          >
           <v-icon class="ms-6 me-4">
              {{ icons.mdiGithub }}
            </v-icon>  -->

           <!-- <theme-switcher></theme-switcher> -->
         <!-- <v-btn icon small class="ms-3">
             <v-icon>
              {{ icons.mdiBellOutline }}
            </v-icon>
          </v-btn>-->
          <app-bar-user-menu></app-bar-user-menu>
        </div>
      </div>
    </v-app-bar>

    <v-main>
      <div class="app-content-container boxed-container pa-0">
        <slot></slot>
      </div>
    </v-main>

    <v-footer v-if="!$route.meta.hideSidebar" app inset color="transparent" absolute height="56" class="px-0">
      <div class="boxed-container w-full">
        <div class="mx-6 d-flex justify-space-between">
          <span>
            &copy; 2022
            <a href="https://mercarue.com" class="text-decoration-none" target="_blank">Mercarue</a></span
          >
        </div>
      </div>
    </v-footer>
  </v-app>
</template>

<script>
import { ref } from '@vue/composition-api'
import { mdiMagnify, mdiBellOutline, mdiGithub } from '@mdi/js'
import VerticalNavMenu from './components/vertical-nav-menu/VerticalNavMenu.vue'
import ThemeSwitcher from './components/ThemeSwitcher.vue'
import AppBarUserMenu from './components/AppBarUserMenu.vue'

export default {
  components: {
    VerticalNavMenu,
    ThemeSwitcher,
    AppBarUserMenu,
  },
  setup() {
    const isDrawerOpen = ref(null)

    return {
      isDrawerOpen,

      // Icons
      icons: {
        mdiMagnify,
        mdiBellOutline,
        mdiGithub,
      },
    }
  },
}
</script>
<!--
<style lang="scss" scoped>
.v-app-bar ::v-deep {
  .v-toolbar__content {
    padding: 0;

    .app-bar-search {
      .v-input__slot {
        padding-left: 18px;
      }
    }
  }
}

.boxed-container {
  max-width: 1440px;
  margin-left: auto;
  margin-right: auto;
}
</style>
-->
<style lang="scss" scoped>
/* Global styles for the app bar */
.v-app-bar ::v-deep {
  .v-toolbar__content {
    padding: 0;

    .app-bar-search {
      .v-input__slot {
        padding-left: 18px;
      }
    }
  }
}

/* Container styles */
.boxed-container {
  max-width: 1500px; // Adjusted max-width for smaller screens
  margin-left: auto;
  margin-right: auto;
  
  
}


/* Footer styles */
.v-footer {
  background-color: var(--v-footer-background, transparent); // Ensure footer background is controlled by a CSS variable
  .boxed-container {
    padding: 0 16px; // Padding for footer content
  }
  .text-decoration-none {
    text-decoration: none; // Remove default underline
  }
}
</style>
